import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "slideright"
};
const _hoisted_2 = {
  class: "unit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createBlock(_component_el_form_item, null, {
    label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.title), 1)]),
    default: _withCtx(() => [_createVNode(_component_el_slider, {
      modelValue: $data.inputNumber,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputNumber = $event),
      min: $props.min,
      max: $props.max,
      onInput: $options.inputChange
    }, null, 8, ["modelValue", "min", "max", "onInput"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input_number, {
      min: $props.min,
      max: $props.max,
      modelValue: $data.inputNumber,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.inputNumber = $event),
      "controls-position": "right",
      onChange: $options.inputChange
    }, null, 8, ["min", "max", "modelValue", "onChange"]), _withDirectives(_createElementVNode("span", _hoisted_2, "px", 512), [[_vShow, $props.showPX]])])]),
    _: 1
  });
}